<template>
  <div id="room">
    <div class="title">{{title}}</div>
    <div class="user-list">
      <user v-for="user of userList" :key="user.id" :user="user"></user>
    </div>
    <footer>
      <span class="iconfont icon-switch-camera" @click="switchCamera()"></span>
      <div class="used-time">通话时长：{{duration}}</div>
    </footer>
  </div>
</template>

<script>
import { getShortName } from '../../utils/config.map';
import user from './components/user';
import { User } from './models/user';
import { TrackModeSession, deviceManager } from 'pili-rtc-web';

export default {
  name: 'wap',
  data () {
    return {
      session: new TrackModeSession(),
      users: new Map(),
      userList: [],
      tracks: new Map(),
      trackList: [],
      localTracks: [],
      caseUsers: {},
      startTime: Date.now(),
      timer: null,
      title: '',
      duration: '',
      timer1: null
    };
  },
  mounted () {
    // 处理案号
    let oId = sessionStorage.getItem('oId');
    let caseId = sessionStorage.getItem('caseId');
    let caseYear = caseId.slice(0, 4);
    let number = caseId.slice(4);
    this.title = this.$config.getOrgTitle(oId,caseId);
    this.getDurationTime();
    window.addEventListener('beforeunload', () => {
      this.leaveRoom();
    });

    let caseUsers = sessionStorage.getItem('users');
    this.caseUsers = JSON.parse(caseUsers);
    this.joinRoom();
  },
  beforeDestroy () {
    this.leaveRoom();
  },
  beforeRouteLeave () {
    this.leaveRoom();
  },
  methods: {
    async joinRoom () {
      let token = sessionStorage.getItem('token');
      let users = await this.session.joinRoomWithToken(token);
      this.session.on('track-add', trackInfos => this.addTracks(trackInfos));
      this.session.on('track-remove', trackInfos => this.removeTracks(trackInfos));
      this.session.on('user-join', user => this.addUser(user));
      this.session.on('user-leave', user => this.removeUser(user));
      this.session.on('disconnect', e => this.onDisconnect(e));
      users.forEach(u => {
        let userInfo = this.caseUsers[u.userId];
        let user = new User({ id: u.userId, name: userInfo.name, role: userInfo.role });
        this.users.set(user.id, user);
      });
      let cameras = deviceManager.deviceInfo.filter(d => d.kind === 'videoinput');
      console.log(cameras, 'cameras #####ooooo')
      this.cameraIds = cameras.map(c => c.deviceId);
      await this.publish();
      let trackIds = this.session.trackInfoList.map(t => t.trackId);
      this.subscribe(trackIds);
    },
    async switchCamera () {
      if (this.cameraIds.length < 2) {
        alert('没有可以切换的摄像头')
        return;
      }
      let trackIds = this.localTracks.map(lt => lt.info.trackId);
      console.log(trackIds, this.localTracks, '要unpublish的track')
      await this.session.unpublish(this.localTracks.map(lt => lt.info.trackId));
      this.tracks.forEach((v, k) => {
        if (this.localTracks.find(lt => lt === v)) {
          this.tracks.delete(k);
        }
      });
      let nextCameraId = this.cameraIds.find(id => id !== this.currentCameraId);
      await this.publish(nextCameraId);
      this.updateUsers()
    },
    async publish (deviceId) {
      let userIds = Object.keys(this.caseUsers).sort();
      // 用户总数
      const totalUserCount = userIds.length;

      // 总宽
      const totalWidth = 800;

      // 总高
      const totalHeight = 600;

      // 列数
      const totalColNum = Math.ceil(Math.sqrt(totalUserCount));
      console.log(totalColNum);

      // 行数
      const totalRowNum = Math.ceil(totalUserCount / totalColNum);
      console.log(totalRowNum);

      // 单个视频宽
      const unitWidth = Math.floor(totalWidth / totalColNum);
      console.log(unitWidth);

      // 单个视频高
      const unitHeight = Math.floor(totalHeight / totalRowNum);
      console.log(unitHeight);


      // 获取 X 坐标
      function getX (index, colCount, unitWidth) {
        const colNum = index % colCount;
        return colNum * unitWidth;
      }

      // 获取 Y 坐标
      function getY (index, colCount, unitHeight) {
        const rowNum = Math.floor(index / colCount);
        return rowNum * unitHeight;
      }

      deviceId = deviceId || this.cameraIds[0];
      this.currentCameraId = deviceId;
      let localTracks = await deviceManager.getLocalTracks({
        audio: { enabled: true },
        video: {
          deviceId,
          enabled: true,
          width: { max: 1280 },
          height: { max: 720 }
        }
      });
      this.localTracks = localTracks;
      let userId = sessionStorage.getItem('phone');
      let index = userIds.findIndex(id => id === userId);
      let videoTrack = localTracks.find(lt => lt.info.kind === 'video');
      let audioTrack = localTracks.find(lt => lt.info.kind === 'audio');
      if (videoTrack) {
        videoTrack.setMaster(true);
      }
      if (audioTrack) {
        audioTrack.setMaster(true);
      }
      await this.session.publish(localTracks);
      this.session.addMergeStreamTracks([{
        trackId: videoTrack.info.trackId,
        x: getX(index, totalColNum, unitWidth),
        y: getY(index, totalColNum, unitHeight),
        w: unitWidth,
        h: unitHeight,
        z: 1
      },
      { trackId: audioTrack.info.trackId }
      ]);
      localTracks.forEach(lt => {
        this.tracks.set(lt.info.trackId, lt);
      });
      this.trackList = Array.from(this.tracks.values());
    },
    unpublish () {
      let trackIds = this.localTracks.map(lt => lt.info.trackId);
      this.session.unpublish(trackIds).then(() => {
      }).catch(err => {
        console.log(err)
      })
    },
    subscribe (trackIds) {
      this.session.subscribe(trackIds).then(tracks => {
        tracks.forEach(t => {
          this.tracks.set(t.info.trackId, t);
        });
        this.trackList = Array.from(this.tracks.values());
        this.updateUsers();
      });
    },

    updateUsers () {
      this.users.clear();
      this.userList = [];
      this.$nextTick(() => {
        this.tracks.forEach(t => {
          if (!this.users.has(t.userId)) {
            let userInfo = this.caseUsers[t.userId];
            this.users.set(t.userId, new User({ id: t.userId, name: userInfo.name, role: userInfo.role }));
          }
          let user = this.users.get(t.userId);
          user.tracks.set(t.info.trackId, t);
        });
        this.userList = Array.from(this.users.values());
      });
    },

    addUser (user) {
      if (this.users.has(user.userId)) {
        return;
      }
      let caseUser = this.caseUsers[user.userId];
      let u = new User({ id: user.userId, name: caseUser.name, role: caseUser.role });
      this.users.set(u.id, u);
    },
    removeUser (user) {
      this.users.delete(user.userId);
      this.userList = Array.from(this.users.values());
    },
    addTracks (trackInfos) {
      this.subscribe(trackInfos.map(t => t.trackId));
    },
    removeTracks (tracks) {
      this.session.unsubscribe(tracks.map(t => t.trackId));
      tracks.forEach(t => {
        this.tracks.delete(t.trackId);
      });
      this.trackList = Array.from(this.tracks.values());
      this.updateUsers();
    },
    onDisconnect (e) {
      this.leaveRoom();
      window.location.href = 'about:blank';
      window.close();
    },
    leaveRoom () {
      this.session.leaveRoom();
      this.localTracks.forEach(lt => lt.release());
      this.localTracks = [];
      this.users.clear();
      this.userList = [];
      this.tracks.clear();
      this.trackList = [];
    },
    getDurationTime () {
      let that = this;
      this.timer1 = setInterval(() => {
        let startTime = sessionStorage.getItem('startTime');
        that.duration = formatTime(Date.now() - startTime)
      }, 1000);
    }
  },
  components: {
    user
  }
};
</script>

<style scoped lang="scss">
#room {
  width: 100vw;
  height: 100%;
  background-color: #262931;
  overflow-y: hidden;

  .title {
    color: #ffffff;
    text-align: center;
    font-size: 20px;
    height: 7vh;
    line-height: 6vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #262931;
  }

  .user-list {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    overflow-y: auto;
    align-content: flex-start;
    padding-top: 7vh;
    padding-bottom: 8vh;
    background-color: #262931;
  }

  footer {
    text-align: center;
    height: 8vh;
    line-height: 8vh;
    background-color: #262931;
    color: #ffffff;
    font-size: 20px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    .iconfont {
      font-size: 30px;
    }
    .iconfont:active {
      opacity: 0.7;
    }
  }
}
</style>
